import React, { useEffect, useState, useRef, useCallback } from "react";
import Connect from "../../../shared/redux/Connect.hoc";
// import Modal from 'react-bootstrap4-modal'
import LoaderSpinner from "../../../shared/components/LoaderSpinner/LoaderSpinner";
import { createNotification } from "../../../utils/utils";
import { MdMoodBad, MdMood } from "react-icons/md";
import { Modal } from "react-bootstrap";
import { fire } from "../../../db/config";

import "./styles.scss";

// ? Redux
import { login } from "../../../shared/redux/action/admin.actions";

// ! Helpers
import { loginHP } from "../../../helpers/Cliente.helper";
import InputIcon from "../../../shared/atoms/input icon";
import Button from "../../../shared/atoms/button";
import { AiOutlineUser } from "react-icons/ai";
import { FaCertificate } from "react-icons/fa";

const Login = ({
  dispatch,
  visibleLogin,
  onCloseLogin,
  onOpenSignin,
  onOpenForgotePass,
}) => {
  const [showLoading, setShowLoading] = useState(false);
  const [alertState, updateAlertState] = useState(false);
  const [alertMessage, updateAlertMessage] = useState("");
  const [showAler, setShowAler] = useState(false);
  const [tokenPush, setTokenPush] = useState();

  const formRef = useRef(null);

  useEffect(() => {
    console.log("--Login.Component.useEffect--");
    const messaging = fire.messaging();
    messaging
      .requestPermission()
      .then(() => {
        messaging.getToken().then((res) => {
          console.log("--Login.Component.useEffect-- res: ", res);

          setTokenPush(res);
        });
      })
      .catch((err) =>
        console.error("--Login.Component-- error requestPermission", err)
      );
  }, []);

  const handleLogin = useCallback(
    async (event) => {
      setShowLoading(true);

      console.log("--Login.Component.handleLogin-- ");

      event.preventDefault();
      const { email, password } = event.target.elements;

      if (email.value === "") {
        showAlert("Por favor ingrese un email");
      } else if (password.value === "") {
        showAlert("Debe ingresar una contraseña");
      }

      const data = {
        email: email.value,
        password: password.value,
        firetoken: tokenPush,
        platform: "web",
        role: "isUser",
        uuid: "web",
      };
      console.log("--Login.Component.handleLogin-- data: ", data);

      await apiLogin(data);
    },
    [tokenPush]
  );

  const apiLogin = async (params) => {
    try {
      console.log("Login.Component.apiLogin tokenPush: ", tokenPush);
      const response = await loginHP(params).catch((error) => {
        console.error("--Login.Component.apiLogin-- error: ", error);
        showAlert(`${error}`);
      });
      console.log("--Login.Component.apiLogin-- response: ", response);
      if (response["code"] === 404) {
        console.log("Login.Component.apiLogin response: ", response);
        createNotification(response["message"], "warn");
        setShowLoading(false);
      }
      if (response["code"] === 403) {
        console.log("Login.Component.apiLogin response: ", response);
        createNotification(response["message"], "warn");
        setShowLoading(false);
      } else {
        console.log("Login.Component.apiLogin response: ", response);
        dispatch(
          login({ user: response["data"], token: response["data"]["_id"] })
        );
        createNotification("Ahora sí puedes pedir el servicio", "success");
        closeModal();
      }
    } catch (error) {
      console.error("Login.Component.apiLogin error: ", error);
    }
  };


  const closeModal = () => {
    console.log("--Login.Component.closeModal--");
    onCloseLogin();
  };

  const showAlert = (message) => {
    console.log("--Login.Component.showAlert--");
    console.log("--Login.Component.showAlert-- message: ", message);
    updateAlertState(true);
    updateAlertMessage(message);
    setTimeout(() => {
      updateAlertState(false);
    }, 2000);
  };

  const showModalSignin = () => {
    console.log("--Login.Component.showModalSignin--");
    onOpenSignin();
  };

  const showModalForgotePass = () => {
    console.log("--Login.Component.showModalForgotePass--");
    onOpenForgotePass();
  };

  return (
    <Modal
      aria-labelledby="contained-modal-title-vcenter"
      show={visibleLogin}
      centered
      onHide={() => closeModal()}
    >
      <Modal.Header closeButton>
        <Modal.Title style={{fontWeight: 'bold'}} className="ms-auto">
          Iniciar Sesión
        </Modal.Title>
      </Modal.Header>
        <hr/>
      <Modal.Body >
       <form onSubmit={handleLogin} ref={formRef} className="Login-Form">
        <InputIcon Icon={AiOutlineUser} name= "email" type="email" placeholder="Email" required={true} />
        <InputIcon customIcon="passwordIcon" Icon={FaCertificate} name= "password" type="password" placeholder="Contraseña" required={true}/>
        <a href="/#" onClick={showModalForgotePass} className="Login-Form-a">¿Olvidaste la contraseña?</a>
        <Button name="Ingresar"/>

       </form>
      </Modal.Body>
      <Modal.Footer style = {{alignSelf : 'center'}}>
            <div className= 'row'>
          
<div className = 'text-center'>

            <a href="/#"
              onClick={showModalSignin}
            >
              <div className= 'txt-register'>
              Regístrarte
              </div>
            </a>

</div>

            </div>
      </Modal.Footer>
    </Modal>

    // <Modal visible={visibleLogin} onClickBackdrop={closeModal} dialogClassName= 'modal-dialog'>
    //   <div className= 'modal-content'>

    //   {showLoading &&
    //     <LoaderSpinner show={showLoading} />
    //   }
    //   <div className="modal-header text-center" >
    //     <h1 className="modal-title w-100 title-modal">Iniciar Sesión</h1>
    //     <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModal} >
    //       <span aria-hidden="true">&times;</span>
    //     </button>
    //   </div>
    //   <div className="modal-body" style = {{borderTop:'solid 2px #F27620',width: '370px'}}>
    //     <div >
    //       <div >
    //         <form onSubmit={handleLogin} ref={formRef}>
    //           {buildForm()}
    //           <div className="text-center mb-3 mt-5 ">
    //             <button type="submit" className="btn btn-primary">Ingresar</button>
    //           </div>
    //           <a className="navbar-brand recoverpass" style={{ color: "blue" }} onClick={showModalForgotePass}>¿Olvidate tu contraseña? </a>
    //           <br />
    //           <a className="navbar-brand recoverpass" style={{ color: "blue" }} onClick={showModalSignin}>Regístrarte </a>
    //         </form>
    //       </div>
    //     </div>
    //   </div>
    //   {
    //     showAler &&
    //     <div className="alert alert-danger" role="alert">
    //       {alertMessage}
    //     </div>
    //   }
    //   </div>
    // </Modal >
  );
};
export default Connect(Login);
